import { createSelector } from "@reduxjs/toolkit";
import { orderBy } from "lodash-es";

import { buildSingleItem } from "shared/utils";
import { IStage } from "Venues/types";
import { API_ENDPOINTS } from "shared/constants";
import { dataMetaSelectorHelper, dataSelector } from "./helpers";

export const stageMetaSelector = (id: string) => dataMetaSelectorHelper(API_ENDPOINTS.STAGE(id));

const dataStageSelector = createSelector(dataSelector, data => data.stage);
export const stageSelectorCreator = (id: string) =>
  createSelector(dataStageSelector, stages => {
    const stage = stages?.[API_ENDPOINTS.STAGE(id)];
    if (stage) {
      return buildSingleItem(stage) as IStage;
    }
    return null;
  });

export const stagesSelectorCreator = (stageIds: string[]) =>
  createSelector(dataStageSelector, stages =>
    orderBy(
      stageIds
        .map(id => {
          const stage = stages?.[API_ENDPOINTS.STAGE(id)];

          if (stage) {
            return buildSingleItem(stage) as IStage;
          }

          return {} as IStage;
        })
        .filter(stage => Object.keys(stage).length),
      "weight"
    )
  );
